export default __webpack_public_path__ + "static/media/content-illustrations-discount-blue.901603cc.svg";